import _ from 'lodash'
import { client as SanityClient } from '~/plugins/global.js'

const query = `
*[_type == "category" && isPublic == true]{ 
    ...
 }`

export default async function getCategoryTree() {
    const allCategories = await SanityClient.fetch(query)
    const sortedCategories = _.sortBy(allCategories, (c) =>
        parseFloat(c.sequence)
    )
    const topLevelCategories = sortedCategories.filter(
        (c) => c.isFeatured === true
    )
    const subCategories = sortedCategories.filter(
        (c) => c.isFeatured === false && c.sequence
    )
    const groupSubCategoriesBySequence = _.groupBy(subCategories, (c) => {
        return Math.floor(parseInt(c.sequence) / 100)
    })
    const CategoryTree = topLevelCategories.map((category) => {
        const sequencePrefix = parseInt(category.sequence) / 100
        return {
            ...category,
            subCategories: groupSubCategoriesBySequence[sequencePrefix] || [],
        }
    })

    return CategoryTree
}
